(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ft-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  var body = document.body;
  var header = document.querySelector('.ft-hdr');
  function headerBottom(){ return header ? Math.round(header.getBoundingClientRect().bottom) : 60; }

  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchInput = document.querySelector('[data-search-input]');
  function closeSearch(){
    if(!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden','true');
    var r = searchOverlay.querySelector('[data-search-results]');
    if(r){ r.hidden=true; r.innerHTML=''; }
    var q = searchOverlay.querySelector('.ft-search__quick');
    if(q) q.style.display='';
  }
  function openSearch(){
    if(!searchOverlay) return;
    closeMega();
    searchOverlay.style.top = headerBottom() + 'px';
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden','false');
    setTimeout(function(){ if(searchInput) searchInput.focus(); }, 60);
  }

  function closeMega(){
    document.querySelectorAll('[data-nav-item].is-open').forEach(function(x){
      x.classList.remove('is-open');
      var b = x.querySelector('[data-mega-toggle]'); if(b) b.setAttribute('aria-expanded','false');
    });
  }
  function positionOpenMega(){
    var open = document.querySelector('[data-nav-item].is-open [data-mega-panel]');
    if(open) open.style.top = headerBottom() + 'px';
  }
  document.querySelectorAll('[data-mega-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      var item = btn.closest('[data-nav-item]');
      var wasOpen = item.classList.contains('is-open');
      closeMega();
      closeSearch();
      if(!wasOpen){
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded','true');
        var panel = item.querySelector('[data-mega-panel]');
        if(panel) panel.style.top = headerBottom() + 'px';
      }
    });
  });
  document.addEventListener('click', function(e){
    if(!e.target.closest('[data-nav-item].has-mega')) closeMega();
  });

  document.querySelectorAll('[data-search-open]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      if(searchOverlay && searchOverlay.classList.contains('is-open')) closeSearch();
      else openSearch();
    });
  });
  document.querySelectorAll('[data-search-close]').forEach(function(c){ c.addEventListener('click', closeSearch); });
  document.addEventListener('click', function(e){
    if(searchOverlay && searchOverlay.classList.contains('is-open') && !e.target.closest('[data-search-overlay]') && !e.target.closest('[data-search-open]')) closeSearch();
  });

  /* ---- PREDICTIVE SEARCH (instant results) ---- */
  if (searchInput && searchOverlay) {
    var resultsEl = searchOverlay.querySelector('[data-search-results]');
    var quickEl = searchOverlay.querySelector('.ft-search__quick');
    var sT, lastQ = '';
    function esc(s){ return (s||'').replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
    function imgOf(p){ var i=(p.featured_image && (p.featured_image.url||p.featured_image)) || p.image || ''; if(i && i.indexOf('shopify')>-1 && i.indexOf('width=')<0){ i += (i.indexOf('?')<0?'?':'&')+'width=120'; } return i; }
    function priceOf(p){ var v=p.price; if(v===undefined||v===null||v==='') return ''; var n=parseFloat(v); if(isNaN(n)) return ''; var pt=n.toFixed(2).split('.'); pt[0]=pt[0].replace(/\B(?=(\d{3})+(?!\d))/g,','); return 'LE ' + pt.join('.'); }
    function showQuick(){ if(resultsEl){ resultsEl.hidden=true; resultsEl.innerHTML=''; } if(quickEl) quickEl.style.display=''; }
    function render(items, q){
      if(!resultsEl) return;
      var html;
      if(!items.length){ html = '<div class="ft-search__empty">No matches for "'+esc(q)+'". Press Enter to search everything.</div>'; }
      else {
        html = items.map(function(p){
          var img = imgOf(p);
          return '<a class="ft-search__res" href="'+esc(p.url)+'">'+
            '<span class="ft-search__res-img"'+(img?' style="background-image:url(\''+esc(img)+'\')"':'')+'></span>'+
            '<span class="ft-search__res-t">'+esc(p.title)+'</span>'+
            '<span class="ft-search__res-p">'+esc(priceOf(p))+'</span></a>';
        }).join('') + '<a class="ft-search__all" href="/search?q='+encodeURIComponent(q)+'&type=product">See all results for "'+esc(q)+'" →</a>';
      }
      resultsEl.innerHTML = html; resultsEl.hidden=false;
      if(quickEl) quickEl.style.display='none';
    }
    searchInput.addEventListener('input', function(){
      var q = searchInput.value.trim();
      clearTimeout(sT);
      if(q.length < 2){ showQuick(); lastQ=''; return; }
      if(q === lastQ) return;
      if(resultsEl){ resultsEl.hidden=false; resultsEl.innerHTML='<div class="ft-search__loading">Searching…</div>'; if(quickEl) quickEl.style.display='none'; }
      sT = setTimeout(function(){
        lastQ = q;
        fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', {headers:{'Accept':'application/json'}})
          .then(function(r){ return r.json(); })
          .then(function(j){
            if(searchInput.value.trim() !== q) return;
            var prods = (j.resources && j.resources.results && j.resources.results.products) || [];
            render(prods, q);
          }).catch(function(){ if(resultsEl) resultsEl.innerHTML='<div class="ft-search__empty">Press Enter to search.</div>'; });
      }, 180);
    });
  }

  var drawer = document.querySelector('[data-ft-mobile-drawer]');
  var opener = document.querySelector('[data-ft-mobile-toggle]');
  var drawerClosers = document.querySelectorAll('[data-ft-mobile-close]');
  function openDrawer(){ if(!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); body.style.overflow='hidden'; }
  function closeDrawer(){ if(!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); body.style.overflow=''; }
  if(opener && drawer) opener.addEventListener('click', openDrawer);
  drawerClosers.forEach(function(c){ c.addEventListener('click', closeDrawer); });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){ closeSearch(); closeMega(); closeDrawer(); }
  });
  window.addEventListener('scroll', function(){
    positionOpenMega();
    if(searchOverlay && searchOverlay.classList.contains('is-open')) searchOverlay.style.top = headerBottom() + 'px';
  });
  window.addEventListener('resize', positionOpenMega);

  function setCount(c){
    if(c==null) return;
    document.querySelectorAll('[data-cart-count]').forEach(function(n){
      n.textContent = c;
      if(c > 0){ n.removeAttribute('hidden'); } else { n.setAttribute('hidden',''); }
    });
  }
  function refreshCount(){ fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){ setCount(c.item_count); }).catch(function(){}); }
  document.addEventListener('cart:updated', function(e){
    var c = e.detail && e.detail.cart ? e.detail.cart.item_count : null;
    if(c!=null){ setCount(c); } else { refreshCount(); }
  });
  /* Robust, theme-agnostic badge sync: after ANY cart mutation (add/change/update/clear),
     re-read /cart.js. Catches add-to-cart from the base theme, apps, and our own sections. */
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\b)/i;
  if(window.fetch){
    var _f = window.fetch;
    window.fetch = function(){
      var url = (arguments[0] && arguments[0].url) || arguments[0] || '';
      var pr = _f.apply(this, arguments);
      try { if(typeof url === 'string' && CART_RE.test(url)){ pr.then(function(){ setTimeout(refreshCount, 80); }).catch(function(){}); } } catch(e){}
      return pr;
    };
  }
  if(window.XMLHttpRequest){
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(m, u){
      try { if(typeof u === 'string' && CART_RE.test(u)){ this.addEventListener('load', function(){ setTimeout(refreshCount, 80); }); } } catch(e){}
      return _open.apply(this, arguments);
    };
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-popup"] && !Shopify.designMode) return;
  try {
    
(function(){
  var el = document.querySelector('[data-ft-popup]');
  if(!el) return;
  var KEY = 'ft_popup_seen_v1';
  var freqDays = parseInt(el.dataset.freq) || 7;
  var delay = (parseFloat(el.dataset.delay) || 6) * 1000;
  var listId = (el.dataset.list || '').trim();
  var pubKey = (el.dataset.key || 'UAF3T9').trim();

  function seenRecently(){
    try { var t = parseInt(localStorage.getItem(KEY) || '0'); return t && (Date.now() - t) < freqDays*86400000; } catch(e){ return false; }
  }
  function markSeen(){ try { localStorage.setItem(KEY, String(Date.now())); } catch(e){} }
  function open(){ el.hidden = false; requestAnimationFrame(function(){ el.classList.add('is-in'); }); }
  function close(){ el.classList.remove('is-in'); markSeen(); setTimeout(function(){ el.hidden = true; }, 320); }

  if(!seenRecently()){
    var t = setTimeout(open, delay);
    /* also trigger on exit-intent (desktop) */
    document.addEventListener('mouseout', function ei(e){
      if(e.clientY <= 0 && !seenRecently() && el.hidden){ clearTimeout(t); open(); document.removeEventListener('mouseout', ei); }
    });
  }

  el.querySelectorAll('[data-ft-popup-close]').forEach(function(c){ c.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && !el.hidden) close(); });

  var emailEl = el.querySelector('[data-ft-popup-email]');
  var msgEl = el.querySelector('[data-ft-popup-msg]');
  var btn = el.querySelector('[data-ft-popup-submit]');
  var formView = el.querySelector('[data-ft-popup-form]');
  var successView = el.querySelector('[data-ft-popup-success]');

  function submit(){
    var email = (emailEl.value || '').trim();
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){ msgEl.textContent = 'Please enter a valid email address.'; msgEl.className = 'ft-pop__msg is-err'; return; }
    if(!listId){ msgEl.textContent = 'Almost ready — add your Klaviyo List ID in the theme settings.'; msgEl.className = 'ft-pop__msg is-err'; return; }
    btn.disabled = true; btn.textContent = '…';
    var payload = { data: { type: 'subscription', attributes: { custom_source: 'Welcome popup', profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: listId } } } } };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(pubKey), { method:'POST', headers:{'Content-Type':'application/json','revision':'2024-10-15'}, body: JSON.stringify(payload) })
      .then(function(r){
        if(r.status === 202 || r.ok){
          markSeen();
          if(formView) formView.hidden = true;
          if(successView) successView.hidden = false;
        } else {
          btn.disabled = false; btn.textContent = el.querySelector('[data-ft-popup-submit]') ? btn.dataset.label || 'Unlock my offer' : 'Unlock my offer';
          msgEl.textContent = 'Something went wrong — please try again.'; msgEl.className = 'ft-pop__msg is-err';
        }
      })
      .catch(function(){ btn.disabled = false; btn.textContent = 'Unlock my offer'; msgEl.textContent = 'Could not submit — please try again.'; msgEl.className = 'ft-pop__msg is-err'; });
  }
  if(btn){ btn.dataset.label = btn.textContent; btn.addEventListener('click', submit); }
  if(emailEl) emailEl.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); submit(); } });

  var codeBtn = el.querySelector('[data-ft-popup-code]');
  if(codeBtn) codeBtn.addEventListener('click', function(){
    var code = codeBtn.dataset.code || '';
    var done = function(){ var em = codeBtn.querySelector('[data-ft-popup-copy]'); if(em) em.textContent = 'Copied ✓'; };
    if(navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(code).then(done).catch(done); } else { done(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-sale-filter"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    var section = document.querySelector('.ft-col');
    if(!section) return;
    if(!/\/collections\/(sale|clearance)/.test(location.pathname)) return;
    var grid = section.querySelector('.ft-col__grid');
    if(!grid) return;
    if(document.querySelector('[data-ft-salef]')) return;

    var TIERS = [
      {key:'all', label:'All',          test:function(){ return true; }},
      {key:'t30', label:'Up to 30%',    test:function(d){ return d>0 && d<=30; }},
      {key:'t40', label:'30-40%',       test:function(d){ return d>30 && d<=40; }},
      {key:'t50', label:'40-50%',       test:function(d){ return d>40; }}
    ];
    var current = 'all';
    var allLoaded = false, loading = false;

    var cnt = section.querySelector('[data-count]');
    var origCount = cnt ? cnt.textContent : '';

    var bar = document.createElement('div');
    bar.className = 'ft-salef';
    bar.setAttribute('data-ft-salef','');
    var lab = document.createElement('span');
    lab.className = 'ft-salef__label'; lab.textContent = 'Discount:';
    bar.appendChild(lab);
    TIERS.forEach(function(t){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ft-salef__chip' + (t.key==='all' ? ' is-on' : '');
      b.textContent = t.label;
      b.setAttribute('data-tier', t.key);
      b.addEventListener('click', function(){ select(t.key); });
      bar.appendChild(b);
    });
    var spin = document.createElement('span');
    spin.className = 'ft-salef__spin'; spin.hidden = true; spin.textContent = 'Loading all items…';
    bar.appendChild(spin);
    grid.parentNode.insertBefore(bar, grid);

    function setActive(){
      bar.querySelectorAll('.ft-salef__chip').forEach(function(c){
        c.classList.toggle('is-on', c.getAttribute('data-tier')===current);
      });
    }
    function tierObj(){ for(var i=0;i<TIERS.length;i++){ if(TIERS[i].key===current) return TIERS[i]; } return TIERS[0]; }
    function discountOf(card){
      var badge = card.querySelector('.ft-col__badge--sale');
      if(badge){ var m = (badge.textContent||'').replace(/[^0-9]/g,''); if(m) return parseInt(m,10); }
      return 0;
    }
    function applyAll(){
      var cards = grid.querySelectorAll('.ft-col__cardwrap'), vis = 0;
      for(var i=0;i<cards.length;i++){
        var show = (current==='all') || tierObj().test(discountOf(cards[i]));
        cards[i].style.display = show ? '' : 'none';
        if(show) vis++;
      }
      if(cnt) cnt.textContent = (current==='all') ? origCount : (vis + ' items');
    }

    /* Pull every remaining page so filtering sees the whole collection, not just page 1. */
    function loadAllPages(done){
      if(allLoaded || loading){ done(); return; }
      loading = true; spin.hidden = false;
      var page = 2, guard = 0;
      function next(){
        if(guard++ > 40){ finish(); return; }
        fetch(location.pathname + '?page=' + page, {headers:{'X-Requested-With':'XMLHttpRequest'}})
          .then(function(r){ return r.ok ? r.text() : ''; })
          .then(function(html){
            if(!html){ finish(); return; }
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var incoming = doc.querySelectorAll('.ft-col__cardwrap');
            if(!incoming.length){ finish(); return; }
            var seen = {};
            grid.querySelectorAll('.ft-col__cardwrap a[href]').forEach(function(a){ seen[a.getAttribute('href')] = 1; });
            var added = 0;
            for(var i=0;i<incoming.length;i++){
              var a = incoming[i].querySelector('a[href]');
              var key = a ? a.getAttribute('href') : null;
              if(key && seen[key]) continue;
              grid.appendChild(document.importNode(incoming[i], true));
              if(key) seen[key] = 1;
              added++;
            }
            if(!added){ finish(); return; }
            page++; next();
          })
          .catch(finish);
      }
      function finish(){ allLoaded = true; loading = false; spin.hidden = true; done(); }
      next();
    }

    function select(key){
      current = key; setActive();
      if(key==='all'){ applyAll(); return; }
      loadAllPages(applyAll);
    }

    try{
      new MutationObserver(function(muts){
        var added=false;
        muts.forEach(function(m){ if(m.addedNodes && m.addedNodes.length) added=true; });
        if(added && current!=='all') applyAll();
      }).observe(grid, {childList:true});
    }catch(e){}
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
  setTimeout(init, 800);
})();

  } catch(e) { console.error(e); }
})();
})();
